export const FEATURE_FLAG_EFFICIENCY_MEASURES = (projectName: string) => (projectName || '').includes('28 Liberty');
